// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import InfoIcon from '../../assets/info.svg';

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.31);
  `,
  SubmitContainer: styled.div`
    background: #FCFCFC;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-50%,0%);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  `,
  CloseBar: styled.div`
    background: #FCFCFC;
    opacity: .9;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 17px 17px 19px;
  `,
  SubmitContent: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 39px 52px 39px 52px;
    overflow-y: auto;
    max-height: 400px;
  `,
  WarningIcon: styled.img.attrs({ src: InfoIcon })`
    margin-right: 30px;
    max-width: 72px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 0 52px 39px 0;
  `,
  CancelButton: styled.button`

    padding: 4px 27px;
    margin-right: 14px;
    color: #7A7A7A;
    font-size: 18px;
    cursor: pointer;

    &:hover{
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
      border-radius: 7px 0px 0px 7px;
      background: #7A7A7A;
      color: #EFEFEF;
      cusor: pointer;
    }
  `,
  SubmitButton: styled.button`
    padding: 4px 27px;
    color: #EF8200;
    font-size: 18px;
    cursor: pointer;

    &:hover{
      border-radius: 0px 7px 7px 0px;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
      background: #EF8200;
      color: #EFEFEF;
      cusor: pointer;
    }
  `,
  WarningMessage: styled.p`
    font-size: 18px;
    margin-top: 10px;
    color: #4F4F4F;
  `,
}

const BlockPopSubmit = (props: any): JSX.Element => {
  const setClickSubmit = props.setClickSubmit;
  const gotoBirfrost = props.gotoBirfrost;
  const messageId = props.messageId;

  const handleClose = () => {
    setClickSubmit(false);
  }

  const handleSubmit = () => {
    gotoBirfrost();
    setClickSubmit(false);
  }

  return (
    <S.PopMask>
      <S.SubmitContainer>
        <S.CloseBar />
        <S.SubmitContent>
          <S.WarningIcon/>
          <S.WarningMessage><FormattedMessage id={'J068'} values={{br: <br/>}}/></S.WarningMessage>
        </S.SubmitContent>
        <S.SubmitAction>
          <S.CancelButton onClick={handleClose}><FormattedMessage id="E065" /></S.CancelButton>
          <S.SubmitButton onClick={handleSubmit}><FormattedMessage id="B039" /></S.SubmitButton>
        </S.SubmitAction>
      </S.SubmitContainer>
    </S.PopMask>
  )
}

export { BlockPopSubmit as default };
